import dashboard from "../../assets/home.svg";
import prexo from "../../assets/prexo.svg";
import vrp from "../../assets/vrp.svg";
import openBox from "../../assets/openBox.svg";
import spare from "../../assets/spare.svg";
import new_phone from "../../assets/new_phone.svg";
import payment from "../../assets/payment.svg";

export const dropdowns = [
  {
    id: "inventory",
    title: "Manage Inventory",
    options: [
      { id: "spares", image: spare, name: "Spares", path: "/inventory/spares" },
      { id: "vrp", image: vrp, name: "VRP", path: "/inventory/vrp" },
      {
        id: "new_phones",
        image: new_phone,
        name: "New Phones",
        path: "/inventory/new_phones",
      },
      { id: "openBox", image: openBox, name: "Open Box", path: "/inventory/open_box" },
      // { id: "prexo", image: prexo, name: "Prexo", path: "prexo" },
    ],
  },
  {
    id: "bulk_deals",
    title: "Manage Bulk Deals",
    options: [
      { id: "spares", image: spare, name: "Spares", path: "bulk_deals/spares" },
      { id: "vrp", image: vrp, name: "VRP", path: "bulk_deals/vrp" },
      {
        id: "new_phones",
        image: new_phone,
        name: "New Phones",
        path: "bulk_deals/new_phones",
      },
      { id: "openBox", image: openBox, name: "Open Box", path: "bulk_deals/open_box" },
      // { id: "prexo", image: prexo, name: "Prexo", path: "prexo" },
    ],
  },
];

export const withoutDropdowns = [
  { id: "home", image: dashboard, name: "Home", path: "/" },
  { id: "orders", image: payment, name: "Orders", path: "orders" },
  { id: "cancellation", image: payment, name: "Cancelled Orders", path: "cancelled_orders" },
   { id: "refund", image: payment, name: "Refund Orders", path: "refund_orders" },
];
